export type Range = { to: number; value: number };
export type Ranges = Range[];
export const getRangeValue = (
  value: number,
  ranges: Ranges,
  outOfRangeValue: number,
): number => {
  // order ranges
  const sortedRanges = [...ranges].sort((a, b) => (a.to > b.to ? 1 : -1));
  const range = sortedRanges.find(({ to }) => {
    return value <= to;
  });

  if (range) return range.value;

  return outOfRangeValue;
};
